export enum ELoginResultType {
    SUCCESS = 'success',
    PASSWORD_EXPIRED = 'password_expired',
}
